import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {DISCOUNT_TYPES, discountInterface, discountSectionsInterface} from "./discounstInterface";
import {setDiscountSections} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";
import {getTotalForDeposit, shouldUseMultipleWorkSheets} from "./discountFunctions";
import {getPriceWithCurrency, getQuotePriceWithTaxes} from "../../misc/helpers";


class DiscountDeposit extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterface),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  render() {
    const {discount, fabricatorSettings, activeQuoteIndex, hasMultipleWorkSheets} = this.props;
    const totalPrice = getTotalForDeposit(activeQuoteIndex, hasMultipleWorkSheets);
    const totalAmount = getQuotePriceWithTaxes(totalPrice);

    return (
      <li className={"discount discount--deposit"}>
        <div className="discount-cell discount-cell--name bold">{discount.name}</div>
        <div className="discount-cell discount-cell--special-amount">
          {totalAmount && discount.type === DISCOUNT_TYPES.percent ? (
            <div className="bold color-gray4" style={{paddingRight: "0.5rem"}}>
              <span>Deposit </span>
              <span className="color-primary"> {discount.amount}%</span>
              <span> of </span>
              <span className="color-primary">{getPriceWithCurrency(fabricatorSettings, totalAmount)}</span>
              <span> = </span>
            </div>
          ) : null}
          {this.renderAmountInput()}
        </div>
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts, workSheetsCount} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex, quotes} = store.quotesState;
  const {jobIsSaving} = store.serverState;
  const {showAllQuotesCartItemsList} = store.cartState;

  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorData: store.fabricatorState,
    fabricatorSettings: store.fabricatorState.settings,
    allWizardsValues,
    activeQuoteIndex,
    workSheetsCount,
    quotes,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
    showAllQuotesCartItemsList,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountDeposit);
